export default __webpack_public_path__ + "static/media/home.bd0bfce5.svg";